import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Icon from './AppIcon';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <Icon name="Loader2" size={48} className="text-primary animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to sign-in if not authenticated
  if (!user) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  // New user onboarding: if onboarding not completed, send to profile selection
  // Skip this check if already on the onboarding pages to avoid redirect loops
  const onboardingPaths = ['/user-type-selection', '/profile-selection-success', '/interactive-onboarding-wizard'];
  const hasCompletedOnboarding = localStorage.getItem('hasCompletedOnboarding');
  if (!hasCompletedOnboarding && !onboardingPaths?.includes(location?.pathname)) {
    return <Navigate to="/user-type-selection" replace />;
  }

  // Render protected content
  return children;
};

export default ProtectedRoute;